import * as React from "react";
import {IAddFruitPayload} from "src/store/actions";
import {EFruits} from "src/store/enums";
import {getId} from "src/utils/utils";

interface IProps {
    boxId?: string;
    addFruit?: (arg: IAddFruitPayload) => void;
    kind?: EFruits;
    size?: number;
}

export class Fruit extends React.Component<IProps, {}> {
    private id = getId('Fruit');

    public componentWillMount() {
        const {boxId, addFruit, kind, size} = this.props;
        if (addFruit && boxId) {
            addFruit({boxId, fruitId: this.id, kind, size})
        }
    }

    public render() {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/abstract/Fruit.tsx